import { Component } from '@angular/core';
import { SessionService } from '../../session.service';

@Component({
    selector: 'app-home-root',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})

export class HomeComponent {

    constructor(
        public sessionService: SessionService
    ) {
    }

    
}
